import React, { Component } from "react";
import LanguageToggle from "../LanguageToggle";
import { withLocalize } from "react-localize-redux";
import {
  Route,
  Link,
  NavLink,
  BrowserRouter as Router
} from "react-router-dom";
import NotificationList from "../../pages/Notifications/NotificationList";
import { LogOut } from "../../GeneralAPI";
import MyModal from "../MyModal";
class NavBar extends Component {
  LogOut = (event) => {

 

    LogOut().then( () => window.location.href = "/login")
    
   };

  render() {
    let langCode = "en";
    if (this.props.activeLanguage !== undefined) {
      langCode = this.props.activeLanguage.code;
    }
    //alert(JSON.stringify(this.props.name))
    return (
      <div id="header" class="header navbar-default">
        <div class="navbar-header">
          <a href="/home" class="navbar-brand">
            <img src="/assets/img/logo/logo.png" width="24" alt="" />
            <b> Student</b> Portal
          </a>
          <button
            type="button"
            class="navbar-toggle"
            data-click="sidebar-toggled"
          >
            <span class="icon-bar" />
            <span class="icon-bar" />
            <span class="icon-bar" />
          </button>
        </div>

        {/* <!-- begin navbar-collapse --> */}
        <div class="collapse navbar-collapse pull-left" id="top-navbar">
          <ul class="nav navbar-nav">
            {/* <li class="dropdown dropdown-lg">
						
              <NavLink  to="/News" class="dropdown-toggle" data-toggle="dropdown"> 
                <i class="fas fa-newspaper fa-fw text-primecolor"></i> News <b class="caret"></b>
              </NavLink> 
						<div class="dropdown-menu dropdown-menu-lg">
							<div class="row">
								<div class="col-lg-4 col-md-4">
									
									
								</div>
								<div class="col-lg-4 col-md-4">
									
									
								</div>
								<div class="col-lg-4 col-md-4">
									
								</div>
							</div>
						</div>
					</li> */}
            <li>
              <NavLink to="/News">
                <i class="fas fa-newspaper fa-fw text-primecolor" /> News
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/AASTMT-Calendar">
                <i class="fas fa-calendar-alt fa-fw text-primecolor" /> AASTMT
                Calendar
              </NavLink>
            </li> */}
          </ul>
        </div>
        {/* <!-- end navbar-collapse --> */}

        <ul class="navbar-nav navbar-right">
          {/* <li>
            <form class="navbar-form">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter keyword"
                />
                <button type="submit" class="btn btn-search">
                  <i class="fa fa-search" />
                </button>
              </div>
            </form>
          </li> */}
          <LanguageToggle />
          <li>
              <a href="#" data-toggle="modal" data-target="#feedbackModal">
                <i class="fas fa-comment fa-fw text-red"  /> FeedBack
              </a>
            </li>
          <li class="dropdown navbar-user">
            <a
              href="javascript:;"
              class="dropdown-toggle"
              data-toggle="dropdown"
            >
              <img src={`api/General/Image/${this.props.ID}`} alt="" />
              <span class="d-none d-md-inline">
                {this.props.name !== undefined &&
                  (langCode == "ar"
                    ? this.props.name.nameArabic
                    : this.props.name.nameEnglish)}
              </span>{" "}
              <b class="caret" />
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              {/* <a href="javascript:;" class="dropdown-item">
                Profile
              </a>
              */}
              <a href="#" class="dropdown-item" onClick={this.props.openProfileModal}>
                <i class="fas fa-lg fa-fw m-r-10 fa-id-card"></i> Profile Details
              </a>
              <a href="#" class="dropdown-item" onClick={this.props.openContactModal}>
                <i class="fas fa-lg fa-fw m-r-10 fa-address-card"></i> Change Contact Info
              </a>
              
              <a href="#" class="dropdown-item"  data-toggle="modal" data-target="#ChangePasswordModal">
                <i class="fas fa-lg fa-fw m-r-10 fa-key"></i> Change Password
              </a> 
              <div class="dropdown-divider" />
              <a onClick={this.LogOut}  class="dropdown-item">
              <i class="fas fa-lg fa-fw m-r-10 fa-power-off"></i> Log Out
              </a>
            </div>
          </li>
          
          <li class="dropdown">
            <a
              href="javascript:;"
              data-toggle="dropdown"
              class="dropdown-toggle f-s-14"
            >
              <i class="fa fa-bell" />
              <span class="label">5</span>
            </a>
            <ul class="dropdown-menu media-list dropdown-menu-right">
              <li class="dropdown-header">NOTIFICATIONS (5)</li>
              <NotificationList limit={5} />

              <li class="dropdown-footer text-center">
                <a href="javascript:;">View more</a>
              </li>
            </ul>
          </li>
        </ul>
              
      </div>
    );
  }
}

export default withLocalize(NavBar);



// WEBPACK FOOTER //
// ./src/components/navbar/NavBar.js